module.exports = __webpack_public_path__ + "static/media/desi.89848a83.webp";